import React from 'react';
import { SettingsCard, ThicknessRow } from '../GlassSettings';
import { SOUNDPROOFING_LAYER_TYPES, SOUNDPROOFING_THICKNESS_OPTIONS } from '../../../../constants/soundproofing';

function FrameSettings({ layer, updateLayerParams }) {
  return (
    <SettingsCard>
      <ThicknessRow
        options={SOUNDPROOFING_THICKNESS_OPTIONS[SOUNDPROOFING_LAYER_TYPES.frame]}
        value={layer.params.thickness}
        onChange={(value) => updateLayerParams(layer.id, (params) => ({ ...params, thickness: value }))}
      />
    </SettingsCard>
  );
}

export default FrameSettings;
